import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { HowItWorks } from "@/components/HowItWorks";
import { WhyPrimeConnect } from "@/components/WhyPrimeConnect";
import { Audience } from "@/components/Audience";
import { Discretion } from "@/components/Discretion";
import { FoundingMembers } from "@/components/FoundingMembers";
import { Footer } from "@/components/Footer";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FAF9F5] text-[#141518]">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <HowItWorks />
      <WhyPrimeConnect />
      <Audience />
      <Discretion />
      <FoundingMembers />
      <Footer />
    </div>
  );
}
